// extracted by mini-css-extract-plugin
module.exports = {"Insurances":"insurance-module--Insurances--UtRZv","Images":"insurance-module--Images---1914","Image":"insurance-module--Image--1TlxY"};